// import logo from './logo.svg';
import './App.css';
import {createBrowserRouter,RouterProvider,} from "react-router-dom"
import Page404 from './Layout/Page404';
import { ConfigProvider } from '../src/Context/ConfigContext'
import routes from './Routes/Routes'
import AppLayout from './Layout/AppLayout';
import Login from './Pages/Login';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



function App() {
  const router = createBrowserRouter([
    { path: '/', element: localStorage.getItem("token_master") ? <AppLayout /> : < Login /> },
    {element: <AppLayout />, errorElement: <Page404 />, children: routes },]);
  return (
    <ConfigProvider>
      <RouterProvider router={router} />
      <ToastContainer />
    </ConfigProvider>
  )

}

export default App;
